/// <reference path="../../app.definition.ts" />

import angular from "angular";


export interface IBroadcastService {
    registerCallBack(name, id, fn);
    removeCallBack(name, id);
    broadcast(name, params?: any[]);
    reset();
}

export class BroadcastService implements IBroadcastService {
    static $inject = [];
    callBacks = {};
    constructor() {

    }
    registerCallBack = (name, id, fn) => {
        if (!this.callBacks[name]) {
            this.callBacks[name] = {};
        }
        this.callBacks[name][id] = fn;
    }

    removeCallBack = (name, id) => {
        if (this.callBacks[name][id]) {
            delete this.callBacks[name][id];
            if (Object.keys(this.callBacks[name]).length == 0) {
                delete this.callBacks[name];
            }
        }
    }

    broadcast(name, params: any[] = []) {
        if (this.callBacks[name]) {
            for (var key in this.callBacks[name]) {
                if (typeof this.callBacks[name][key] == "function") {
                    this.callBacks[name][key](...params);
                }
            }
        }
    }

    reset = () => {
        this.callBacks = {};
    }

}

angular.module('eCareVault.common.services')
    .service('BroadcastService', BroadcastService);